// types
import {
  WARRANTY_CLEAR_MODULE,
  WARRANTY_DELETE_DAMAGE,
  WARRANTY_UPDATE_MATERIAL_SUMMARY,
  WARRANTY_UPDATE_SINISTER_SUMMARY,
  WARRANTY_UPDATE_SINISTER_ID,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_UPDATE_CREATED,
  WARRANTY_UPDATE_ZIP_CODE,
  WARRANTY_UPDATE_MORE_THAN_TWO_YEARS,
  WARRANTY_UPDATE_PROPERTY_TYPE,
  WARRANTY_UPDATE_RESIDENT_TYPE,
  WARRANTY_UPDATE_COORDINATES,
  WARRANTY_GET_SINISTER_SUMMARY,
  WARRANTY_GET_REPORT,
  WARRANTY_GET_MATERIAL_SUMMARY,
  WARRANTY_GET_SINISTER,
  WARRANTY_UPDATE_PROPS,
  UPDATE_LOADER,
  WARRANTY_UPDATE_ADDRESS,
  WARRANTY_PATCH_REPAIR_TYPE,
  WARRANTY_UPDATE_REPAIR_TYPE,
  WARRANTY_UPDATE_HEIGHT,
  WARRANTY_UPDATE_WIDTH,
  WARRANTY_UPDATE_AREA,
  WARRANTY_UPDATE_UNIT,
  WARRANTY_UPDATE_DAMAGE_REPARATION_TYPE,
  WARRANTY_UPDATE_FLUXID,
  WARRANTY_UPDATE_SHOW_EXTRA_INFO,
  WARRANTY_EXISTING_SINISTER,
  WARRANTY_UPDATE_ANSWERED_EXTRA_INFO
} from '@/store/types'

// api
import { apiGetDamage, apiDeleteDamage, apiGetReparationType } from '@/services/API/damages'
import { apiGetReport } from '@/services/API/reports'
import { apiGetMaterials } from '@/services/API/gag'
import {
  apiGetSinister,
  apiPostSinister,
  apiPatchRepairType
} from '@/services/API/sinister'

export default {
  [WARRANTY_GET_SINISTER_SUMMARY]({ state, commit }) {
    return apiGetDamage(state.sinisterId).then(damages => {
      if (damages) {
        commit(WARRANTY_UPDATE_SINISTER_SUMMARY, damages)
      }
    })
  },
  [WARRANTY_DELETE_DAMAGE]({ state, dispatch }, payload) {
    return apiDeleteDamage(state.sinisterId, payload).then(() => {
      dispatch(WARRANTY_GET_SINISTER_SUMMARY)
      dispatch(WARRANTY_GET_REPORT)
    })
  },
  [WARRANTY_GET_REPORT]({ state, commit }) {
    return apiGetReport(state.sinisterId)
      .then(report => {
        commit(WARRANTY_UPDATE_REPORT, report)
        commit(WARRANTY_UPDATE_REPAIR_TYPE, report.sinister.rep_type)
        return report
      })
      .catch(() => {
        commit(WARRANTY_UPDATE_REPORT, {})
      })
  },
  [WARRANTY_PATCH_REPAIR_TYPE]({ state }, payload) {
    const b = { sinister_id: state.sinisterId, rep_type: payload.rep_type, analysis_view: payload.analysis_view }
    return apiPatchRepairType(b).then(report => {
      return report
    })
  },
  [WARRANTY_GET_MATERIAL_SUMMARY]({ state, commit }) {
    return apiGetMaterials(state.sinisterId)
      .then(materials => {
        commit(WARRANTY_UPDATE_MATERIAL_SUMMARY, materials)
      })
      .catch(() => {
        commit(WARRANTY_UPDATE_MATERIAL_SUMMARY, {})
      })
  },
  [WARRANTY_GET_SINISTER]({ state, commit, dispatch }, payload) {
    commit(UPDATE_LOADER, true, { root: true })
    return apiGetSinister(payload)
      .then(async sinister => {
        commit(WARRANTY_UPDATE_SINISTER_ID, payload)
        if (sinister.zip_code) {
          commit(WARRANTY_UPDATE_ZIP_CODE, sinister.zip_code)
        }
        commit(
          WARRANTY_UPDATE_MORE_THAN_TWO_YEARS,
          sinister.more_than_two_years
        )
        commit(WARRANTY_UPDATE_PROPERTY_TYPE, sinister.real_estate)
        commit(WARRANTY_UPDATE_RESIDENT_TYPE, sinister.declarant)
        if (sinister.lat && sinister.lon) {
          commit(WARRANTY_UPDATE_COORDINATES, {
            lat: parseFloat(parseFloat(sinister.lat).toFixed(10)),
            lng: parseFloat(parseFloat(sinister.lon).toFixed(10))
          })
        }
        if (sinister.address !== null && sinister.address !== '') {
          commit(WARRANTY_UPDATE_ADDRESS, sinister.address)
        }

        // CREATED should be the last!
        commit(WARRANTY_UPDATE_CREATED, true)
        commit(WARRANTY_UPDATE_SHOW_EXTRA_INFO, sinister.show_extra_info)
        commit(WARRANTY_UPDATE_ANSWERED_EXTRA_INFO, sinister.extra_info_is_answered)
        await dispatch(WARRANTY_GET_SINISTER_SUMMARY).finally(() => {
          commit(UPDATE_LOADER, false, { root: true })
        })
        return { isSinisterFound: true }
      })
      .catch(() => {
        // commit(WARRANTY_CLEAR_MODULE)
        commit(WARRANTY_UPDATE_SINISTER_ID, payload)
        commit(WARRANTY_UPDATE_CREATED, true)
        commit(UPDATE_LOADER, false, { root: true })
        return { isSinisterFound: false }
      })
  },
  [WARRANTY_UPDATE_PROPS]({ state, commit }) {
    if (state.created) {
      commit(UPDATE_LOADER, true, { root: true })
      return apiPostSinister(
        state.sinisterId,
        state.zipCode,
        state.moreThanTwoYears,
        state.propertyType,
        state.residentType,
        state.coordinates.lat,
        state.coordinates.lng,
        state.address
      )
        .catch(errorCode => {
          apiGetSinister(this.stateWarrantySinisterId).then(sinister => {
            commit(WARRANTY_UPDATE_ADDRESS, sinister.address)
            commit(WARRANTY_UPDATE_ZIP_CODE, sinister.zip_code)
          })

          return Promise.reject(errorCode)
        })
        .finally(() => {
          commit(UPDATE_LOADER, false, { root: true })
        })
    }
  },
  [WARRANTY_UPDATE_AREA]({ state, commit }, payload) {
    commit(WARRANTY_UPDATE_HEIGHT, payload.height)
    commit(WARRANTY_UPDATE_WIDTH, payload.width)
    commit(WARRANTY_UPDATE_UNIT, payload.selected)
  },
  [WARRANTY_UPDATE_DAMAGE_REPARATION_TYPE]({ state, commit, dispatch }, payload) {
    apiGetReparationType(payload.damageId, payload.repType).then(() => {
      dispatch(WARRANTY_GET_REPORT)
    })
  },
  [WARRANTY_UPDATE_FLUXID]({ state, commit }, payload) {
    commit(WARRANTY_UPDATE_HEIGHT, payload.height)
  },
  [WARRANTY_EXISTING_SINISTER]({ commit }, payload) {
    commit(WARRANTY_EXISTING_SINISTER, payload)
  }
}
